import { EventEmitter } from 'fbemitter';

const emitter = new EventEmitter();

let total = 0;

setInterval(() => {
  if (total % 30 === 0) {
    emitter.emit('seconds.30', ++total);
  }
}, 1000);

export default emitter;



/** WEBPACK FOOTER **
 ** ./src/utils/clock.js
 **/